// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2h_3T","col":"styles_col__1Gxlh","fulfillmentStatus":"styles_fulfillmentStatus__3C8l8","emailCol":"styles_emailCol__1-H38"};